import React from 'react';
import USBSelectableChips from '@usb-shield/react-selectable-chips';
import '@usb-shield/react-selectable-chips/dist/library/styles/index.css';
import './dpsCategoryFilter.scss';

function DpsCategoryFilter({
    componentRef,
    productList,
    handleStatusUpdate,
}) {
    return (
        <div className="category-filter-wrapper">
            <USBSelectableChips
                key={componentRef}
                options={productList}
                statusUpdateCallback={handleStatusUpdate}
                headingLevel="h3"
                headingText="Filter by category"
            />
        </div>
    );
}
export default DpsCategoryFilter;
